$(document).ready(function () {

    // slider goods
    var swiperGoods = new Swiper('.swiper-goods', {
        loop: true,
        pagination: {
            el: '.swiper-pagination-goods',
            clickable: true,
        },
        navigation: {
            prevEl: '.goods-slider-prev',
            nextEl: '.goods-slider-next',
        }
    });

    // goods type list
    $(".goods-type-btn").click(function () {
        $(".goods-type-btn").removeClass("active");
        $(this).addClass("active");
    });

    // count goods
    $(".count-btn-minus").click(function () {
        var input = $(this).parents(".goods-count").find(".goods-count-input");
        var value = input.val();
        if (value != 0) {
            input.val(--value);
        }
    });
    $(".count-btn-plus").click(function () {
        var input = $(this).parents(".goods-count").find(".goods-count-input");
        var value = input.val();
        input.val(++value);    
    });

    // FAQs 
    $(".faq-title").click(function () {
        var parent = $(this).parents(".faq-wrap");
        var blockFaq = $(this).parents(".faq-block");
        if (!$(blockFaq).hasClass("faq-active")) {
            $(parent).find(".faq-block").removeClass("faq-active");
            $(parent).find(".faq-info").hide(300);
            $(blockFaq).addClass("faq-active");
            $(blockFaq).find(".faq-info").show(300);
        }
        else {
            $(parent).find(".faq-block").removeClass("faq-active");
            $(parent).find(".faq-info").hide(300);
        }
    });

    // customer slider
    var swiperCustomer = new Swiper('.swiper-customer', {
        slidesPerView: 3.4,
        loop: true,
        spaceBetween: 30,
        navigation: {
            prevEl: '.customer-slider-prev',
            nextEl: '.customer-slider-next',
        },
        breakpoints: {
            1199: {
                slidesPerView: 2.7
            },
            767: {
                slidesPerView: 1.8,
                spaceBetween: 20,
                centeredSlides:true,
            }
        }
    });

    // select color
    $(".select-color").change(function () {
        var val = $(this).val();
        let src = '';
        switch (val) {
            case 'Pearl':
                src = 'img/goods-type-icon-1.png';
                break;
            case 'Sky':
                src = 'img/goods-type-icon-2.png';
                break;
            case 'Ocean':
                src = 'img/goods-type-icon-3.png';
                break;
            case 'Jade':
                src = 'img/goods-type-icon-4.png';
                break;
            case 'Forest':
                src = 'img/goods-type-icon-5.png';
                break;
            case 'Ice':
                src = 'img/goods-type-icon-6.png';
                break;
            case 'Polar':
                src = 'img/goods-type-icon-7.png';
                break;
            case 'Champagne':
                src = 'img/goods-type-icon-8.png';
                break;
        }
        $(".seletected-image").attr('src', src);
    });
});
